// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* YouTube/Netflix Style Video List */

/* Smooth scrolling for horizontal sections */
.video-carousel-container {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* Hide scrollbar but keep functionality */
.video-carousel-container::-webkit-scrollbar {
  height: 8px;
}

.video-carousel-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.video-carousel-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.video-carousel-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Video card hover effects */
.video-card-enhanced {
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: center center;
}

.video-card-enhanced:hover {
  transform: scale(1.05);
  z-index: 10;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.8);
}

/* Preview animation on hover (Netflix-style) */
.video-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.video-card-enhanced:hover .video-preview {
  opacity: 1;
}

/* Loading skeleton animation */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.skeleton-shimmer {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.05) 25%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0.05) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* Tab indicator animation */
.tab-indicator {
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Smooth fade in for content */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-fade-in {
  animation: fadeIn 0.5s ease-out forwards;
}

/* Grid to list view transition */
.view-transition {
  transition: all 0.3s ease;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .video-card-enhanced:hover {
    transform: scale(1.02);
  }
  
  .video-carousel-container {
    scroll-snap-type: x mandatory;
  }
  
  .video-card-enhanced {
    scroll-snap-align: start;
  }
}

/* Dark theme enhancements */
.dark-gradient-overlay {
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0.7) 100%
  );
}

/* Floating action buttons */
.fab-actions {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 1000;
}

/* Progress bar for videos */
.video-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: #e50914;
  transition: width 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/VideoList/VideoListEnhanced.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,yCAAyC;AAC3C;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,yDAAyD;AAC3D;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;EACE;;;;;GAKC;AACH;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B","sourcesContent":["/* YouTube/Netflix Style Video List */\n\n/* Smooth scrolling for horizontal sections */\n.video-carousel-container {\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Hide scrollbar but keep functionality */\n.video-carousel-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.video-carousel-container::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.video-carousel-container::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n}\n\n.video-carousel-container::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Video card hover effects */\n.video-card-enhanced {\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transform-origin: center center;\n}\n\n.video-card-enhanced:hover {\n  transform: scale(1.05);\n  z-index: 10;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.8);\n}\n\n/* Preview animation on hover (Netflix-style) */\n.video-preview {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.video-card-enhanced:hover .video-preview {\n  opacity: 1;\n}\n\n/* Loading skeleton animation */\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.skeleton-shimmer {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.05) 25%,\n    rgba(255, 255, 255, 0.1) 50%,\n    rgba(255, 255, 255, 0.05) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n/* Tab indicator animation */\n.tab-indicator {\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Smooth fade in for content */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.content-fade-in {\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n/* Grid to list view transition */\n.view-transition {\n  transition: all 0.3s ease;\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 768px) {\n  .video-card-enhanced:hover {\n    transform: scale(1.02);\n  }\n  \n  .video-carousel-container {\n    scroll-snap-type: x mandatory;\n  }\n  \n  .video-card-enhanced {\n    scroll-snap-align: start;\n  }\n}\n\n/* Dark theme enhancements */\n.dark-gradient-overlay {\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(0, 0, 0, 0.3) 50%,\n    rgba(0, 0, 0, 0.7) 100%\n  );\n}\n\n/* Floating action buttons */\n.fab-actions {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  z-index: 1000;\n}\n\n/* Progress bar for videos */\n.video-progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  background-color: #e50914;\n  transition: width 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
